import { render, staticRenderFns } from "./TouchNodata.vue?vue&type=template&id=9baf0466&scoped=true&"
import script from "./TouchNodata.vue?vue&type=script&lang=js&"
export * from "./TouchNodata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9baf0466",
  null
  
)

export default component.exports